__turbopack_context__.v({
  "footerBox": "_9RHIsG_footerBox",
  "footerSecondaryBox": "_9RHIsG_footerSecondaryBox",
});
